var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5722 12.2949L10.5574 14.1666L9.90964 14.8143L7.55285 12.4576L4.60634 15.4041L3.95792 15.4034V14.7556L6.90444 11.8091L4.54765 9.45235L5.19536 8.80464L7.06636 8.78908L11.2793 4.57614L10.6903 3.98712L11.3387 3.3387L16.0233 8.02329L15.3749 8.6717L14.7851 8.08198L10.5722 12.2949ZM6.10824 9.71751L9.64377 13.253L9.62963 11.9421L14.1374 7.43427L11.9277 5.22456L7.41992 9.73236L6.10824 9.71751Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLine);
export default __webpack_public_path__ + "static/media/pin_line.76b38195bc1c55665ac39569e68804b3.svg";
export { ForwardRef as ReactComponent };